import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { listConfigVersions } from '../../../api/applications.js'

export default function ApplicationConfigVersionsPage() {
  const { id } = useParams()
  const [rows, setRows] = useState([])
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!id) return undefined

    let cancelled = false
    setStatus('loading')
    setError(null)

    listConfigVersions(id)
      .then((payload) => {
        if (cancelled) return
        setRows(Array.isArray(payload) ? payload : [])
        setStatus('ok')
      })
      .catch((err) => {
        if (cancelled) return
        setRows([])
        setError(err?.message ?? String(err))
        setStatus('error')
      })

    return () => {
      cancelled = true
    }
  }, [id])

  function formatDate(value) {
    if (!value) return ''
    try {
      return new Date(value).toLocaleString()
    } catch {
      return String(value)
    }
  }

  return (
    <section className="card sectionCard">
      <div className="cardTitle">Config Versions</div>
      <p className="muted sectionDescription">
        Actual config JSON for each bundle version.
      </p>

      {error && (
        <pre className="codeBlock codeBlockError">{error}</pre>
      )}

      <table className="table" aria-label="Config versions list">
        <thead>
          <tr>
            <th>Bundle version</th>
            <th>Status</th>
            <th>Updated</th>
            <th>Config JSON</th>
          </tr>
        </thead>
        <tbody>
          {status === 'loading' && (
            <tr>
              <td colSpan={4} className="muted">Loading…</td>
            </tr>
          )}

          {status === 'ok' && rows.length === 0 && (
            <tr>
              <td colSpan={4} className="muted">No config versions yet.</td>
            </tr>
          )}

          {status === 'ok' && rows.map((row) => (
            <tr key={row.id || row.bundleVersion}>
              <td>{row.bundleVersion || ''}</td>
              <td>{row.status || ''}</td>
              <td>{formatDate(row.updatedAt)}</td>
              <td>
                {row.config ? (
                  <details className="configJsonDetails">
                    <summary className="configJsonSummary">View JSON</summary>
                    <pre className="codeBlock inlineMessage configJsonPre">
                      {JSON.stringify(row.config, null, 2)}
                    </pre>
                  </details>
                ) : (
                  ''
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
